import React from 'react';
import { withRouter } from 'react-router';
import LiteForm from './LiteForm';

class LiteEdit extends React.Component {
    constructor(props){
        super(props);
        this.id = props.match.params.id;
    }

    render(){
        return (
            <div>
                <LiteForm id={this.id} />
            </div>
        );
    }

}
export default withRouter(LiteEdit);



// WEBPACK FOOTER //
// ./src/pages/LiteScenes/LiteEdit.js